import { useI18n } from 'builder/hooks/useI18n'
import { ButtonTheme } from 'builder/components/Button'
import {
  Benefit,
  Benefits,
  BenefitText,
  CancelAnytime,
  Container,
  ContinueButton,
  Icon,
  Title,
} from './styles'
import AI from './icons/ai.svg'
import BOARD from './icons/board.svg'
import MONEY from './icons/money.svg'
import RECRUITERS from './icons/recruiters.svg'
import RESUMES from './icons/resumes.svg'
import SUPORT from './icons/suport.svg'
import TAILOR from './icons/tailor.svg'
import PAPER from './icons/500.svg'
import EYES from './icons/eyes.svg'
import BOOKS from './icons/books.svg'

export const SubscriptionBenefits = ({
  continueOnClick,
  theme = ButtonTheme.confirmative,
  isHistoricalLeads = false,
}: {
  continueOnClick: () => void
  theme?: ButtonTheme
  isHistoricalLeads?: boolean
}) => {
  const hostname = window.location.hostname
  const isCareerIo = hostname === 'career.io' || hostname === 'staging.career.io'
  const { i18n } = useI18n()

  return (
    <Container>
      <Title>{i18n.t('builder.billing.benefits.title')}</Title>
      <Benefits>
        {isHistoricalLeads ? (
          <>
            <Benefit>
              <Icon src={TAILOR} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.one.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.one.description')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={BOOKS} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.two.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.two.description')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={RESUMES} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.three.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.three.description')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={EYES} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.four.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.four.description')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={AI} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.five.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.five.description')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={PAPER} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.six.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.six.description')}
              </BenefitText>
            </Benefit>
            <Benefit className="blue">
              <Icon src={MONEY} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.seven.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.seven.description')}
              </BenefitText>
            </Benefit>
            <Benefit className="blue">
              <Icon src={SUPORT} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                <BenefitText className="medium">
                  {i18n.t('builder.billing.benefits.historical_leads.eight.title')}
                </BenefitText>{' '}
                {i18n.t('builder.billing.benefits.historical_leads.eight.description')}
              </BenefitText>
            </Benefit>
          </>
        ) : (
          <>
            <Benefit>
              <Icon src={TAILOR} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.one')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={PAPER} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.two')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={RECRUITERS} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.three')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={RESUMES} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.four')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={AI} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.five')}
              </BenefitText>
            </Benefit>
            <Benefit>
              <Icon src={BOARD} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.six')}
              </BenefitText>
            </Benefit>
            <Benefit className="blue">
              <Icon src={MONEY} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.seven')}
              </BenefitText>
            </Benefit>
            <Benefit className="blue">
              <Icon src={SUPORT} />
              <BenefitText $isHistoricalLeads={isHistoricalLeads}>
                {i18n.t('builder.billing.benefits.eight')}
              </BenefitText>
            </Benefit>
          </>
        )}
      </Benefits>
      <ContinueButton onClick={continueOnClick} theme={theme}>
        {isHistoricalLeads
          ? i18n.t('builder.billing.benefits.stay_ready')
          : i18n.t('builder.billing.benefits.continue')}
      </ContinueButton>
      <CancelAnytime>
        {i18n.t('builder.billing.benefits.cancel')}{' '}
        <CancelAnytime className="blue">
          support@{isCareerIo ? 'career' : 'resume'}.io
        </CancelAnytime>
      </CancelAnytime>
    </Container>
  )
}
